import React, { useCallback, useEffect, useState } from 'react';
import Wrapper from "../components/Wrapper";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { auto, global, input, lang, menu, profile } from "../translate";
import { Link, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import Api from "../Api";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import Account from "../helpers/Account";
import qs from "query-string";
import ProfileComponent from "../components/ProfileComponent";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { profileRequest } from "../store/actions/users";
const { REACT_APP_SERVER } = process.env;
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const style = {
    bgcolor: 'background.paper',
    // boxShadow: 24,
    p: 4,
    overflow: 'auto'
};

function Profile(props) {
    const [form, setForm] = useState({
        phone: '',
        email: '',
        name: '',
        fio: '',
        login: '',
        pass: '',
        notify: 3,
        webhook: '',
        webhookEnabled: false,
        itn: '',
        itnCheck: false,
        fioCheck: false,
        nameCheck: false,
        manager: '',
        manager_contact: '',
        m_email: '',
        m_name: '',
        manager_workDay: '',
        manager_workHour: '',
    })
    const [manager, setManager] = useState([])
    const [repass, setRepass] = useState('')
    const location = useLocation()
    const query = qs.parse(location.search, { arrayFormat: 'comma' });
    const userData = useSelector((state) => state.users.userData)
    const profileData = useSelector((state) => state.users.ursData)
    const [copy, setCopied] = useState(false)
    const [code, setCode] = useState('')
    const [promocode, setPromocode] = useState('')
    const [promocodeLoading, setPromocodeLoading] = useState(false)

    const dispatch = useDispatch()
    const handleWheel = useCallback((event) => {
        event.target.blur();
        event.preventDefault();
    }, []);
    const handleCopy = useCallback(() => {
        if (navigator.clipboard) {
            setCopied(true)
            navigator.clipboard.writeText(code).catch(function () { });
            setTimeout(() => {
                setCopied(false)
            }, 1000)
        }
    }, [code])
    useEffect(() => {
        const webhook = typeof userData?.webhook === 'string' ? userData.webhook : ''
        const notify = +userData?.notify === 5 ? 3 : userData?.notify
        const profileForm = {
            ...userData,
            password: '',
            notify,
            webhook,
            webhookEnabled: Boolean(webhook.trim()),
        }
        if (userData?.manager_id) {
            setForm({ ...profileForm, manager: manager.find(m => +m?.id === +userData?.manager_id), manager_id: manager.find(m => +m?.id === +userData?.manager_id)?.id })
        } else {
            setForm(profileForm)
        }
    }, [userData, manager])

    useEffect(() => {
        (async () => {
            try {
                const { data } = await Api.manager()
                setCode(userData?.key)
                if (profileData.admingroup === 1 || userData.admgroup === 1) {
                    setManager(data.manager)
                } else {
                    setManager(data.manager.filter(m => m?.id !== 3 && m?.id !== 15))
                }
            } catch (e) {

            }
        })()
    }, [profileData, userData])

    const handleChange = useCallback((name, ev) => {
        setForm((prevState) => ({
            ...prevState,
            [name]: ev
        }))

        if (name === 'manager_id') {
            setForm((prevState) => ({
                ...prevState,
                manager: manager.find(m => +m?.id === +ev)
            }))
        }
    }, [manager])

    const handleSubmit = useCallback(async (ev) => {
        try {
            ev.preventDefault()
            if (!Account.getUrsToken() && userData?.phone !== form?.phone) {
                toast.error(lang[+localStorage.getItem('atsLang')] === 'en-AU' ? 'Only your manager can change the username' : lang[+localStorage.getItem('atsLang')] === 'ru' ? 'Изменить имя пользователя может только ваш менеджер' : 'Միայն ձեր մենեջերը կարող է փոխել օգտանունը')
                return
            }
            if (!Account.getUrsToken() && userData?.name !== form?.name) {
                toast.error(lang[+localStorage.getItem('atsLang')] === 'en-AU' ? 'Only your manager can change the username' : lang[+localStorage.getItem('atsLang')] === 'ru' ? 'Изменить имя пользователя может только ваш менеджер' : 'Միայն ձեր մենեջերը կարող է փոխել օգտանունը')
                return
            }
            if (repass !== form.password) {
                toast.error(lang[+localStorage.getItem('atsLang')] === 'en-AU' ? 'Passwords are not identical' : lang[+localStorage.getItem('atsLang')] === 'ru' ? 'Пароли не идентичны' : 'Գաղտնաբառերը նույնը չեն')
                return
            }

            if (!Account.getUrsToken() && form.name !== userData.name) {
                toast.error(lang[+localStorage.getItem('atsLang')] === 'en-AU' ? 'Only your manager can change the username' : lang[+localStorage.getItem('atsLang')] === 'ru' ? 'Изменить имя пользователя может только ваш менеджер' : 'Միայն ձեր մենեջերը կարող է փոխել օգտանունը')
                return
            }
            const webhookUrl = form.webhookEnabled ? String(form.webhook || '').trim() : ''
            if (form.webhookEnabled && !webhookUrl) {
                toast.error('Invalid webhook URL')
                return
            }
            await Api.editMember({
                ...form,
                notify: +form.notify === 5 ? 3 : form.notify,
                webhook: webhookUrl,
            }, Account.getUrsToken(), lang[+localStorage.getItem('atsLang')], location.pathname)
            toast.success('Success')
        } catch (e) {
            toast.error(e.response.data.message)
        }
    }, [form, userData, repass, lang])

    const handleApplyPromocode = useCallback(async () => {
        if (!promocode.trim()) {
            toast.error('Enter promocode')
            return
        }
        try {
            setPromocodeLoading(true)
            const { data } = await Api.applyPromocode(promocode.trim())
            const daysAdded = data?.days_added
            toast.success(
                daysAdded
                    ? `Promocode applied: +${daysAdded} day${daysAdded === 1 ? '' : 's'} added to your trial`
                    : 'Promocode applied'
            )
            setPromocode('')
            dispatch(profileRequest())
        } catch (e) {
            toast.error(e?.response?.data?.message || 'Failed to apply promocode')
        } finally {
            setPromocodeLoading(false)
        }
    }, [promocode, dispatch])

    const appliedPromocode = String(userData?.applied_promocode ?? form.applied_promocode ?? '').trim()

    return (
        <>
            <Helmet>
                <title>
                    {menu.profile[+localStorage.getItem('atsLang') || 1]}
                </title>
            </Helmet>
            <Wrapper>
                <div className="tableParent">
                    <Box sx={style}>
                        <div className="d-flex flex-row justify-content-between">
                            <h3>
                                {profile.profile[+localStorage.getItem('atsLang') || 1]}
                            </h3>
                            <Link style={{ cursor: 'pointer' }} to="/auto_call">
                                <CloseIcon />
                            </Link>
                        </div>
                        <form onSubmit={handleSubmit} className="row" style={{ margin: '20px 0' }}>
                        {query.add  || (Cookies.get('viewer') && Cookies.get('original'))? null : <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                <span>API-KEY</span>
                                <p className="d-flex align-items-center" style={{ margin: '10px 0', border: '1px solid #ccc', width: 'fit-content' }}>
                                <pre id="amoKey" className="m-0" style={{ background: '#f2f3f7', padding: 10, margin: 0 }}>{code} </pre>
                                 <p onClick={handleCopy} style={{ margin: '0 20px', cursor: 'pointer', fontSize: 20 }}>
                                    <FontAwesomeIcon icon={faCopy} />
                                    </p>
                                    </p>
                            </label>}
                            
                            <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                {query.add ? null : <p>{form.clientIp}</p>}
                                <span>
                                    {profile.num[+localStorage.getItem('atsLang') || 1]} :
                                </span>
                                <input onWheel={handleWheel} type="number" value={form.phone}
                                    onChange={(ev) => handleChange('phone', ev.target.value)} />
                            </label>

                            <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                <span>
                                    {profile?.itn[+localStorage.getItem('atsLang') || 1]} :
                                </span>
                                <ProfileComponent type="number" form={form} handleChange={handleChange} handleWheel={handleWheel} form_name="itn" />

                            </label>
                            {query.add ? null : <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                <span>
                                    {profile.mail[+localStorage.getItem('atsLang') || 1]} :
                                </span>
                                <input 
                                placeholder='email@example.com'
                                type="mail" value={form.email}
                                    onChange={(ev) => handleChange('email', ev.target.value)} />


                            </label>}
                            {query.add ? null : REACT_APP_SERVER !== 'Beeline' ? <p className="col-md-12 count">
                                <p className="checkbox_p text-black">
                                    <span>{profile.info[+localStorage.getItem('atsLang') || 1]}</span>
                                </p>
                            </p> : null}
                            {query.add ? null : REACT_APP_SERVER !== 'Beeline' && form.webhookEnabled ? <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                <span>
                                    {profile.webhook[+localStorage.getItem('atsLang') || 1]} :
                                </span>
                                <input
                                    placeholder="https://example.com/webhook"
                                    value={form.webhook || ''}
                                    onChange={(ev) => handleChange('webhook', ev.target.value)}
                                />
                            </label> : null}
                            {query.add? null : REACT_APP_SERVER !== 'Beeline' ? <p className="col-md-12 count">
                                <p className="checkbox_p">
                                    {["phone", "email", "none", "two"].map((key, index) => (
                                        <label key={index} className="d-flex align-items-center">
                                            <input
                                                type="checkbox"
                                                checked={+form.notify === index + 1}
                                                onChange={() => handleChange('notify', index + 1)}
                                            />
                                            <span>{profile[key][+localStorage.getItem('atsLang') || 1]}</span>
                                        </label>
                                    ))}
                                    <label className="d-flex align-items-center">
                                        <input
                                            type="checkbox"
                                            checked={!!form.webhookEnabled}
                                            onChange={() => handleChange('webhookEnabled', !form.webhookEnabled)}
                                        />
                                        <span>{profile.webhook[+localStorage.getItem('atsLang') || 1]}</span>
                                    </label>
                                </p>
                            </p> : null}
                            {copy ? <div className="copied" style={{bottom:"unset"}}>Copied</div> : null}

                            {query.add ? null : REACT_APP_SERVER !== 'Beeline' ? <hr style={{ margin: '20px 0' }} /> : null}
                            {query.add ? null : (+form.testmode === 1 && !!form.test_period) ? (
                                <>
                                    <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                        <span>Test period</span>
                                        <input readOnly value={form.test_period ? new Date(form.test_period).toLocaleString() : ''} />
                                    </label>
                                    <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                        <span>Promocode</span>
                                        {appliedPromocode ? (
                                            <span style={{ display: 'block', margin: '10px 0', fontWeight: 600 }}>{appliedPromocode}</span>
                                        ) : (
                                            <div className="d-flex align-items-center" style={{ gap: 8 }}>
                                                <input
                                                    value={promocode}
                                                    onChange={(ev) => setPromocode(ev.target.value.toUpperCase())}
                                                    placeholder="Enter promocode"
                                                />
                                                <button
                                                    type="button"
                                                    className="addBtn"
                                                    style={{ padding: '6px 12px' }}
                                                    disabled={promocodeLoading}
                                                    onClick={handleApplyPromocode}
                                                >
                                                    {promocodeLoading ? '...' : 'Apply'}
                                                </button>
                                            </div>
                                        )}
                                    </label>
                                </>
                            ) : null}
                            <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                <span>
                                    {profile.name[+localStorage.getItem('atsLang') || 1]} :
                                </span>
                                <ProfileComponent type="text" form={form} handleChange={handleChange} handleWheel={handleWheel} form_name="fio" />

                            </label>
                            <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                <span>
                                    {profile.login[+localStorage.getItem('atsLang') || 1]} :
                                </span>
                                <ProfileComponent type="number" form={form} handleChange={handleChange} handleWheel={handleWheel} form_name="name" />
                            </label>
                            {query.add ? null : <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                <span>
                                    {profile.pass[+localStorage.getItem('atsLang') || 1]} :
                                </span>
                                <input value={form.password}
                                    onChange={(ev) => handleChange('password', ev.target.value)} />
                            </label>}
                            {query.add ? null : <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                <span>
                                    {profile.repass[+localStorage.getItem('atsLang') || 1]} :
                                </span>
                                <input value={repass}
                                    onChange={(ev) => setRepass(ev.target.value)} />
                            </label>}
                            <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                <span>
                                    {profile.manager[+localStorage.getItem('atsLang') || 1]} :
                                </span>
                                <select disabled={!Cookies.get('viewer') && !Cookies.get('original')} className='manager_select' value={form.manager_id || 0}
                                    onChange={(ev) => handleChange('manager_id', ev.target.value)}>
                                    <option value="0">{input.select[+localStorage.getItem('atsLang') || 1]}</option>
                                    {manager.length ? manager.map(m => (
                                        <option key={m.id} value={m.id}>{m.name}</option>
                                    )) : null}
                                </select>
                            </label>
                            {query.add ? null : <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                <span>
                                    {profile.manager_contact[+localStorage.getItem('atsLang') || 1]} :
                                </span>
                                <input readOnly value={form.manager?.phone}
                                    onChange={(ev) => handleChange('manager_contact', ev.target.value)} />
                            </label>}
                            {query.add ? null : <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                <span>
                                    {profile.m_email[+localStorage.getItem('atsLang') || 1]} :
                                </span>
                                <input readOnly value={form.manager?.email}
                                    onChange={(ev) => handleChange('m_email', ev.target.value)} />
                            </label>}
                            {query.add ? null : <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                <span>
                                    {profile.m_name[+localStorage.getItem('atsLang') || 1]} :
                                </span>
                                <input readOnly value={form.manager?.name}
                                    onChange={(ev) => handleChange('m_name', ev.target.value)} />
                            </label>}
                            {query.add ? null : <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                <span>
                                    {profile.manager_workDay[+localStorage.getItem('atsLang') || 1]} :
                                </span>
                                <input
                                    readOnly
                                    value={form.manager?.days}
                                    onChange={(ev) => handleChange('manager_workDay', ev.target.value)} />
                            </label>}
                            {query.add ? null : <label style={{ margin: '20px 0' }} className="col-md-12 count">
                                <span>
                                    {profile.manager_workHour[+localStorage.getItem('atsLang') || 1]} :
                                </span>
                                <input readOnly
                                    value={form.manager?.hours}
                                    onChange={(ev) => handleChange('manager_workHour', ev.target.value)} />
                            </label>}
                            <div className="d-flex flex-row justify-content-center">
                                <button className="addBtn" onClick={handleSubmit}>
                                    {global.edit[+localStorage.getItem('atsLang') || 1]}
                                </button>
                            </div>
                        </form>
                    </Box>

                </div>

            </Wrapper>
        </>

    );
}

export default Profile;
